const initialState = {
  bidRequests: [],
};

const BidRequests = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_BID_REQUESTS':
      return { bidRequests: action.bidRequests || [] };
    default:
      return state;
  }
};

export default BidRequests;
